var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWI(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_170_7329)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.31125 0.8125C1.21133 0.8125 0.492188 1.53476 0.492188 2.48407C0.492188 3.41241 1.18991 4.15527 2.26904 4.15527H2.28992C3.41135 4.15527 4.10925 3.41241 4.10925 2.48407C4.08829 1.53476 3.41135 0.8125 2.31125 0.8125Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.679688 5.47656H3.8952V15.1506H0.679688V5.47656Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.7931 5.25C10.0585 5.25 8.89529 6.88001 8.89529 6.88001V5.47705H5.67969V15.1511H8.89511V9.74873C8.89511 9.45951 8.91608 9.17075 9.00104 8.96394C9.23349 8.38642 9.76248 7.78812 10.6508 7.78812C11.8144 7.78812 12.2797 8.67527 12.2797 9.97578V15.1511H15.495V9.60416C15.495 6.63272 13.9085 5.25 11.7931 5.25Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_170_7329"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWI);
export default __webpack_public_path__ + "static/media/w-i.70798cd259114270daa63fbd7d770048.svg";
export { ForwardRef as ReactComponent };